import React from 'react';
import ReactDOM from 'react-dom/client';
import LiqpayGeneratorApp from "./components/LiqpayGeneratorApp";

const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(
    <React.StrictMode>
        <LiqpayGeneratorApp />
    </React.StrictMode>
)
